import React, { useState, useEffect, useRef } from 'react';
import SliderProductsContainer from 'containers/SliderProducts';
import CmsService from 'services/CMS';
import PropTypes from 'prop-types';
import WrapperOptimizer from 'components/WrapperOptimizer';
import style from './style.scss'; //NOSONAR


const NewShelfTabSlider = ({data, dateServer}) => {
    const [tab, setTab] = useState(0);
    const [tabsArray, setTabsArray] = useState([]);

    const slider = useRef('');
    const tabsRef = useRef([]);
    const scroller = useRef();
    let principalTitle = data?.title ? data?.title : ''

    useEffect(() => {

        let shelfTab = data ? data.tabs : [];
        shelfTab = shelfTab.filter((item) => {
            return item.collection && item.active && CmsService.validDatesItem(item, dateServer);
        })
        setTabsArray(shelfTab);

    }, [data]);

    const notProducts = (value, i) => {
        if(!value && tabsArray && tabsArray.length){
            let _tabs = [...tabsArray];
            _tabs.splice(i, 1);
            setTabsArray(_tabs);
        }
    }

    const setItem = (pos) => {

        if(!(tabsRef.current && tabsRef.current[pos])) return false;

        const element = scroller.current;
        const coordScroll = element.getBoundingClientRect();
        const coorNewX = tabsRef.current[pos].getBoundingClientRect();
        if((coorNewX.x + coorNewX.width) > coordScroll.width){
            const tam = coorNewX.left + coorNewX.width - coordScroll.x;
            element.scrollBy(tam - coordScroll.width, 0)
        }

        if(coorNewX.x < coordScroll.x){
            const tam = Math.round(coorNewX.x - coorNewX.width) + coordScroll.x;
            element.scrollBy(tam, 0)
        }

        setTab(pos);
    };

    return (
        <section className="new-tabs-slider-content">
            <div className="principal-title">{principalTitle}</div>
            <div className="new-tabs-titles" >
                <div className={'new-slider-tabs-titles'} ref={slider}>
                    <ul className="slides-tabs" ref={scroller}>
                        {tabsArray.map((dataTab, i) => {
                            return (
                                <li key={i} ref={el => (tabsRef.current[i] = el)} className={"new-tab-title-content" + (tab === i ? ' active' : '')} onClick={() => setItem(i)}>
                                    <div className={'shelf-title mobile-click' + (tab === i ? ' active' : '') } key={i} >{dataTab.title}</div>
                                </li>)
                        })}
                    </ul>
                </div>
            </div>
            {tabsArray.map((dataTab, i) => {
                return (
                    <div key={i} className={'tab-slider' + (tab === i ? ' active' : '')}>
                        <WrapperOptimizer typeComponent="home_sliders_products">
                            {(dataWrapper) => {
                                return <SliderProductsContainer options={{ collections: 'H:' + dataTab.collection, position: i }} listTitle={' Card M con filtros' } tab={tab} callbackNotProducts={(value) => notProducts(value, i)} campaignData={dataWrapper} newProductShelf={true}/>
                            }}
                        </WrapperOptimizer>
                    </div>)
            })}
        </section>
    )
}


NewShelfTabSlider.propTypes = {
    data: PropTypes.object,
    dateServer: PropTypes.number
};

export default NewShelfTabSlider;
